<template>
  <div>
    <van-notice-bar
      left-icon="volume-o"
      v-if="is_labeled"
      mode="closeable"
      class="notice-bar"
      :text="$getConfigValue('INDEX_NOTICE_LABEL')"
    />
    <div class="keep-unlogin" v-if="!spining">
      <div
        v-if="isLogin"
        class="logout-account"
        @click="showLogout"
        v-ans="{ event_id: 'switch_account_click' }"
      >
        切换账号
      </div>
      <div
        class="keep-header"
        :style="`background-image: url(${headerBackground})`"
      >
        <!-- <div
          class="to-home"
          v-ans="{ event_id: 'vistor_click_bought_top' }"
          @click="toHome"
        /> -->
      </div>
      <!-- <div class="keep-packages">
        <div
          v-for="(item, index) in packages"
          @click="currentPackageIndex = index"
          :class="{
            'keep-package-item': true,
            [`keep-package-${item.item_code}`]: true,
            active: currentPackageIndex === index,
          }"
          v-ans="{
            event_id: 'package_item_click',
            name: item.name,
            type: item.type,
            item_code: item.type,
          }"
          :key="index"
        >
          <div class="keep-package-inner">
            <div
              v-if="item.tag || $getConfigValue(`PACKAGE_TAG_${item.type}`)"
              class="pacakage-tag"
            >
              {{
                getSellText(
                  item,
                  item.tag || $getConfigValue(`PACKAGE_TAG_${item.type}`)
                )
              }}
            </div>
            <div>
              <div class="package-name">{{ item.name | splitName }}</div>
              <div class="package-amount">
                ¥{{ item.price
                }}<span class="face-value">¥{{ item.face_value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <van-image class="keep-package-desc" :src="packageDescImage"></van-image> -->
      <div class="keep-benefits">
        <div
          :class="['benefit-item', `benefit-item-${item.display_code}`]"
          v-for="item in catesgoryBenefit"
          :key="item.display_code"
        >
          <div
            class="benefit-top-left"
            v-if="!item.display_code.startsWith('table')"
          >
            {{ item.desc || item.name }}
          </div>
          <ul :class="['benefit-spu', `benefit-spu-${item.display_code}`]">
            <li
              :class="['benefit-spu-item', `benefit-spu-${spu.product_code}`]"
              v-for="spu in item.list"
              :key="spu.id"
            >
              <div class="benefit-spu-inner">
                <div
                  class="benefit-spu-top-label"
                  :class="
                    (spu.display_code === 'train' ||
                      spu.display_code === 'hotel') &&
                    `benefit-spu-top`
                  "
                  v-if="item.display_code.startsWith('oakvip_benefit')"
                >
                  <div
                    class="benefit-spu-selling"
                    v-if="spu.selling_points && is_labeled"
                  >
                    {{ spu.selling_points }}
                  </div>
                  <a
                    v-if="spu.display_code === 'train'"
                    href="https://network.dragonpass.com.cn/airport/list?loungeType=lounge"
                    class="benefit-spu-right"
                    >使用城市 ></a
                  >
                  <router-link
                    v-else-if="spu.display_code === 'hotel'"
                    to="/hotel/list?benefitType=hotel"
                    class="benefit-spu-right"
                    >查看更多 ></router-link
                  >
                </div>
                <van-image
                  class="benefit-spu-img"
                  :class="
                    item.display_code.startsWith('oakvip_benefit') &&
                    spu.display_code !== 'table' &&
                    'benefit_detail_img'
                  "
                  lazy-load
                  fit="cover"
                  :src="spu.display_img_url"
                />
              </div>
            </li>
          </ul>
          <template
            v-if="item.display_code === `table_${currentPackage.item_code}`"
          >
            <div class="benefit-top-left">
              {{ item.name }}
            </div>
            <van-image
              class="benefit-spu-img"
              lazy-load
              fit="cover"
              :src="item.display_img_url"
              v-if="item.display_code === `table_${currentPackage.item_code}`"
            />
          </template>
        </div>
        <div
          v-ans="{ event_id: 'vistor_click_rule' }"
          :class="['fold-btn', isFold && 'isFold']"
          @click="isFold = !isFold"
        >
          GoGo 大会员活动规则
          <svg-icon class="arrow" iconClass="arrow2" />
        </div>
        <div :class="['keep-rule', isFold && 'isFold']">
          <div v-html="is_labeled ? ruleConfig : namespaceInfo.rule" />
        </div>
      </div>
      <div
        :style="`display: ${showButton ? 'block' : 'none'}`"
        @click="totop"
        class="totop"
      ></div>
      <!-- <div class="fixed-contain">

        <div class="footer-package-methods package-methods">
          <div
            v-for="item in filterMethods"
            :key="item.channel"
            @click="currentChannel = item"
            v-ans="{
              event_id: 'method_bottom_click',
              name: item.name,
              channel: item.channel,
            }"
            :class="{
              'method-item': true,
              actived: currentChannel.channel === item.channel,
              [`${item.channel}`]: true,
            }"
          >
            <div class="method-check" :class="`${item.channel}`">
              <div
                class="method-onCheck"
                v-if="currentChannel.channel === item.channel"
              ></div>
            </div>
            <div class="method-inner">
              <div class="method-name">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div
          class="fixed-used animate-run"
          v-ans="{
            event_id: 'vistor_click_bottom_apply',
            package_name: currentPackage.name,
            package_type: currentPackage.type,
            channel: currentChannel.channel,
          }"
          @click="open(packages[currentPackageIndex])"
        >
          <div class="footer-price">
            <small>¥</small>{{ currentPackage.price }}
            <span class="footer-facevalue"
              >¥{{ currentPackage.face_value }}</span
            >
          </div>
          <div class="footer-text">立即开通</div>
        </div>
        <div class="footer-count" v-if="!keepActivity.showSellCount">
          {{ sellText }}
          <van-count-down class="count-down" :time="countup">
            <template #default="timeData">
              <span class="block">{{ timeData.hours | zero }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.minutes | zero }}</span>
              <span class="colon">:</span>
              <span class="block">{{ timeData.seconds | zero }}</span>
            </template>
          </van-count-down>
        </div>
        <div class="agreement-wrap">
          <van-checkbox
            class="checkbox"
            v-model="checked"
            v-ans="{ event_id: 'vistor_click_agreement' }"
            icon-size="14px"
            checked-color="#c19030"
            shape="square"
          ></van-checkbox>
          <div class="agreement-text">
            <div v-if="currentChannel.channel === alipayGoConfig.channel">
              {{ alipayGoConfig.desc }}
            </div>
            <div v-else-if="currentPackage.isRenew">
              次{{ currentPackage.renewPackage.period_unit }}起按{{
                currentPackage.renewPackage.normal_price
              }}元/{{
                currentPackage.renewPackage.period_unit
              }}自动续费，可在支付宝中随时关闭。
              <span v-if="keepEntry"
                >Keep 会员将直充到你当前在app登录的账户中</span
              >
            </div>
            <div
              class="keep-agreement"
              v-if="currentChannel.channel !== alipayGoConfig.channel"
            >
              购买即代表接受<span @click="keepAgreement" class="link"
                >《Keep付费会员用户服务协议》</span
              >
              &amp;<span @click="oakAgreement" class="link"
                >《橡树服务协议》</span
              >
            </div>
          </div>
        </div>
      </div> -->
      <div class="fixed-contain" v-if="!isLogin">
        <div
          class="fixed-contain-inner"
          v-ans="{
            event_id: 'vistor_click_bottom_apply',
            package_name: currentPackage.name,
            package_type: currentPackage.type,
            channel: currentChannel.channel,
          }"
        >
          <van-button type="primary" block round @click="showLogin"
            >立即登录</van-button
          >
        </div>
      </div>
      <div
        :class="{
          height120: !isLogin,
          height30: isLogin,
          'is-renew': currentPackage.isRenew,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import animateScrollTo from "animated-scroll-to";
import { NoticeBar } from "vant";

import { geetest_appid } from "@/config";
import { getNetworkType, jsonSafeParse, storage } from "@/utils";
import { queryFirstPeriod, queryLoopData, queryPeriodSku } from "@/apis/home";
import {
  getIndexCategory,
  getIndexClassList,
  getPackageList,
  getPaymethod,
} from "@/apis/product";
import ans from "@/utils/ans";
import loginKeepDialog from "@/components/loginKeepDialog";
import { toPayV2 } from "@/helper/pay";
import qs from "qs";
const baseDate = dayjs("2022-1-26");

export default {
  components: {
    [NoticeBar.name]: NoticeBar,
  },
  props: {},
  data() {
    return {
      isFold: true,
      methods: [],
      checked: false,
      packages: [],
      loops: [],
      phone: "",
      verifycode: "",
      package_enum: {
        KE12: {
          face_real_value: 276,
          text: "放弃会员，一年将损失",
        },
        KE06: {
          face_real_value: 138,
          text: "放弃会员，半年将损失",
        },
        KE03: {
          face_real_value: 76,
          text: "放弃会员，三个月将损失",
        },
        KE01: {
          face_real_value: 29,
          text: "放弃会员，一个月将损失",
        },
      },
      session_code: "",
      count: 60,
      currentPackage: {},
      currentPackageIndex: 0,
      currentChannel: {},
      spining: true,
      showModal: false,
      showButton: false,
      usedNumber: 61 + dayjs().diff(baseDate, "day"),
      filterMethods: [],
      login_phone_number: storage.getItem("login_phone_number") || "",
      catesgoryList: [],
      alipayGoConfig: jsonSafeParse(this.$getConfigValue("ALIPAY_GO_3MONTH")),
      alipayPopup: {
        show: false,
      },
      keepEntry:
        !!this.$route.query.once || !!sessionStorage.getItem("keepEntry"),
      ruleConfig: "",
    };
  },
  filters: {
    splitName(str) {
      if (typeof str !== "string") {
        return str;
      }
      if (str.includes("·")) {
        return str.split("·")[1];
      }
      return str;
    },
  },
  computed: {
    ...mapGetters(["getConfigValue"]),
    ...mapState([
      "isWebchat",
      "source",
      "namespace",
      "namespaceInfo",
      "token",
      "userInfo",
      "showKeepLogin",
      "isMember",
      "userLabel",
    ]),
    is_labeled() {
      return (
        this.userLabel?.includes("keep新用户") ||
        this.userLabel?.includes("keep回购用户")
      );
    },
    // 获取header背景图
    headerBackground() {
      // 旧图 https://common-h5-dev.xiangshuheika.com/static/upload/20236272b6fc102708d4b608d918a07c2493dc8.png
      const category = this.catesgoryList.find(
        (item) => item.display_code === "header"
      );
      return category?.display_img_url;
    },
    // 获取分类
    catesgoryBenefit() {
      const copyList = JSON.parse(JSON.stringify(this.catesgoryList));
      copyList.forEach((item) => {
        if (item.display_code === "keep_oakvip") {
          item.list = item.list.filter(
            (r) => r.display_code === this.currentPackage.item_code
          );
        }
      });
      const category = copyList.filter((r) => {
        if (["banner", "header", "member_package"].includes(r.display_code)) {
          return false;
        }
        if (r.display_code.startsWith("oakvip_benefit")) {
          return (
            r.display_code == `oakvip_benefit_${this.currentPackage.item_code}`
          );
        }
        return true;
      });

      return category;
    },
    packageDescImage() {
      const category = this.catesgoryList.find(
        (item) => item.display_code === "member_package"
      );
      if (!category) {
        return "";
      }
      const item = category.list.find(
        (item) => item.display_code === this.currentPackage.item_code
      );
      if (
        this.currentPackage.name === "连续包季" ||
        this.currentPackage.item_code === "KE06"
      )
        return item.icon_img_url;
      return item?.display_img_url;
    },
    normalMember: {
      get() {
        return this.isMember;
      },
      set(isMember) {
        this.changeState({ isMember });
      },
    },
    countup() {
      return dayjs().endOf("day").diff(dayjs(), "second") * 1000;
    },
    sellText() {
      const item = this.packages[0];
      const t = this.$getConfigValue("SELL_TEXT");
      return this.getSellText(item, t);
    },
    isLogin() {
      return !!this.token;
    },
    getExtraPhone() {
      const phone_number = this.login_phone_number;
      return phone_number.slice(0, 3) + "****" + phone_number.slice(-4);
    },
    keepActivity() {
      const activity = this.$getConfigValue("KEEP_MEMBER_OPEN_ACTIVITY");
      if (!activity) {
        return {};
      }
      try {
        return JSON.parse(activity);
      } catch (e) {
        console.log(e);
        return {};
      }
    },
  },
  async mounted() {
    if (this.userInfo.is_member) {
      this.$router.push("/index");
      return;
    }
    document.addEventListener("scroll", this.onscroll, false);
    this.is_labeled &&
      ans.pageView("keep_grayscale_visitor", {
        namespace: this.namespace,
      });
    if (this.$route.query.once) {
      sessionStorage.setItem("keepEntry", 1);
    }
    await this.fetchPackage();
    await this.fetchCategory();
    const nettype = getNetworkType();
    if (nettype === "wifi") {
      // 可选方案：
      // 1: 提示用户关闭wifi 进行体验
      // 2: 直接降级走其他验证形式
    } else {
      // stpe3: 初始化H5一键登录
      this.initOlinstance = this.initGol();
    }

    if (this.showKeepLogin) {
      this.changeState({ showKeepLogin: false });
      if (this.initOlinstance) {
        this.loading = this.$loading("加载中...", { forbidClick: false });
        ans.track("vistor_click_quick_login", { namespace: this.namespace });
        this.initOlinstance.gateway();
      } else {
        this.showLogin();
      }
    }
    this.ruleConfig = this.$getConfigValue("KEEP_RULE_CONFIG");
  },
  methods: {
    ...mapMutations(["changeState"]),
    ...mapActions(["onePassLogin"]),
    getSellText(item, text) {
      if (!item || !text) {
        return "";
      }
      const discount = Math.ceil((item.price / item.face_value) * 10);
      return text.replace(/{discount}/g, discount);
    },
    onscroll() {
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      if (top > 500) {
        if (!this.showButton) {
          this.showButton = true;
        }
      } else {
        if (this.showButton) {
          this.showButton = false;
        }
      }
    },
    showLogin() {
      loginKeepDialog
        .show({
          ns: this.namespace,
          agreement: ` 购买则视为同意<a
          href="https://mo.gotokeep.com/prime/vip/agreement"
          class="login-agreement-text"
          >《keep付费会员用户服务协议》</a
        >和<a
          href="https://cdn.xiangshuheika.com/h5/agreement/keep.html"
          class="login-agreement-text"
          >《橡树服务协议》</a
        >`,
        })
        .then((res) => {
          // 解决isMember信息不会立刻更新
          this.normalMember = res.is_member;
          this.login_phone_number = res.login_phone_number;
          ans.track("vistor_click_login_success", {
            namespace: this.namespace,
          });
          this.loginSuccess(res);
        });
      ans.track("vistor_click_verify_login", {
        namespace: this.namespace,
        event_type: "EXP",
      });
    },
    initGol() {
      let olinstance = new window.GOL({
        app_id: geetest_appid,
        app: "GoGo大会员",
        logo: "https://cdn.xiangshuheika.com/static/keep/onelogin-logo.png",
        product: "popup",
        logoWidth: "60px",
        buttonBackgroundActive: "#FF5001",
      });
      // step4: 成功失败回调
      olinstance
        .onTokenFail((e) => {
          this.loading && this.loading.clear();
          // 获取token失败 走降级处理 走短信或者其他登录方式 用户可根据业务做不同判断
          console.log("授权错误", e);
          // 30001表示关闭授权窗口
          if (e.code !== 30001) {
            this.initOlinstance = null;
          }
          this.showLogin();
        })
        .onTokenSuccess(async (e) => {
          console.log(e); // e：获取token成功后返回object包含： {token: '', phone: '', process_id: '', auth_code: ''//电信授权页面暂不支持以下授权页面自定义参数}
          const data = {
            app_id: geetest_appid,
            ...e, // 获取token成功后的数据 包含了 token, phoen ,process_id,auth_code(电信)
          };
          try {
            const userInfo = await this.onePassLogin({
              platform: "route",
              namespace: this.namespace,
              source: this.$route.query.source || "default",
              hideMsg: true,
              ...data,
            });
            this.login_phone_number = userInfo.login_phone_number;
            ans.track("vistor_click_quick_login_success", {
              namespace: this.namespace,
            });
            this.loading && this.loading.clear();
            this.$toast("登录成功");
            this.loginSuccess(userInfo);
          } catch (e) {
            console.log(e, "error");
            this.loading && this.loading.clear();
            this.$toast("登录失败，请使用手机验证码登录");
            setTimeout(() => {
              this.showLogin();
            }, 800);
          }
        });
      return olinstance;
    },
    keepAgreement() {
      location.href = "https://mo.gotokeep.com/prime/vip/agreement";
    },
    oakAgreement() {
      location.href = "https://cdn.xiangshuheika.com/h5/agreement/keep.html";
    },

    async fetchCategory() {
      const catesgory = await getIndexCategory({
        namespace: this.namespace,
        opened_page: "visitor",
        source: this.source,
      });
      const catesgorys = catesgory.data;
      const productList = await getIndexClassList({
        title: catesgorys.map((r) => r.name).join(","),
        opened_page: "visitor",
        namespace: this.namespace,
      });
      catesgorys.forEach((item) => {
        item.list = productList.data[item.name];
      });
      this.catesgoryList = catesgorys;
    },

    async fetchPackage() {
      const loading = this.$loading();
      try {
        const [methods, res, loopdata] = await Promise.all([
          getPaymethod({
            namespace: this.namespace,
            product_type: this.namespace.toUpperCase(),
            source: "default",
            is_vip: "T",
          }),
          getPackageList({ namespace: this.namespace, source: "default" }),
          queryLoopData({ activity_type: "keep_visitor" }),
        ]);
        const packages = res.data;
        this.loops = loopdata.data.data_list;

        this.methods = [...methods];
        this.packages = packages;
        await this.fetchPeriod(methods, packages);
      } finally {
        this.spining = false;
        loading.clear();
      }
    },
    async fetchPeriod(methods, packages) {
      const renewPackages = await queryPeriodSku();
      if (this.alipayGoConfig.name) {
        renewPackages.data.push({
          item_code: this.alipayGoConfig.item_code,
          normal_price: this.alipayGoConfig.normal_price,
          first_price: this.alipayGoConfig.first_price,
          channel: this.alipayGoConfig.channel,
          name: this.alipayGoConfig.name,
          period_unit: this.alipayGoConfig.period_unit,
          tag: this.alipayGoConfig.tag,
          order: this.alipayGoConfig.order,
        });
      }
      // 过滤支付方式跟套餐
      const renews = renewPackages.data.filter(
        (r) =>
          methods.some((item) => r.channel === item.channel) &&
          packages.some((o) => o.item_code === r.item_code)
      );
      let firstPersigns = null;
      if (this.isLogin) {
        const res = await queryFirstPeriod({
          item_code_list: renews.map((r) => r.item_code).join("~"),
        });
        firstPersigns = res.data;
      }
      // 如果用户是首次签约，就使用first_price 否则按normal_price给用户续费
      if (firstPersigns) {
        renews.forEach((item) => {
          const firstPersign =
            firstPersigns.find((r) => r.item_code === item.item_code) || {};
          item.is_first_pay = firstPersign.is_first_pay;
          item.first_price = firstPersign.is_first_pay
            ? item.first_price
            : item.normal_price;
        });
      }

      let i = 0;
      while (i < packages.length) {
        const item = packages[i];
        const renew = renews.find((r) => r.item_code === item.item_code);
        if (renew) {
          packages.splice(i, 0, {
            ...item,
            ...renew,
            card_type_cn: item.name,
            renewPackage: { ...renew },
            price: renew.first_price,
            package_price: item.price,
            isRenew: true,
          });
          i++;
        }
        i++;
      }
      packages.sort((a, b) => a.order - b.order);
      this.packages = [...packages];
      this.currentPackage = this.packages[0];
    },

    showDialog() {
      this.showModal = true;
      ans.track("vistor_click_retain", {
        namespace: this.namespace,
        event_type: "EXP",
      });
    },

    // 退出登录
    showLogout() {
      if (this.keepEntry) {
        this.$alert({
          title: "温馨提示",
          confirmButtonText: "好的",
          message: "请在app-头像-设置-账号与安全-退出登录然后切换账号",
        });
      } else {
        this.$confirm({
          message: `<div class="logout-confirm">
            当前已登录账号
          </div>
          <div class="logout-confirm-phone">
            ${this.getExtraPhone}
          </div>`,
          className: "logout-confirm",
          confirmButtonText: "退出并重新登录",
          cancelButtonText: "取消",
        }).then(() => {
          storage.removeItem("token");
          storage.removeItem("login_phone_number");
          this.login_phone_number = "";
          this.normalMember = false;
          this.changeState({
            isMember: false,
            memberInfo: {},
            userInfo: {},
            token: "",
            ptoken: "",
          });
          if (this.initOlinstance) {
            this.loading = this.$loading("加载中...", { forbidClick: false });
            ans.track("vistor_click_quick_login", {
              namespace: this.namespace,
            });
            this.initOlinstance.gateway();
          } else {
            this.showLogin();
          }
        });
      }
    },
    toHome() {
      this.clickType = "tohome";
      if (!this.currentPackage.name) {
        this.currentPackage = this.packages[this.currentPackageIndex];
      }
      if (storage.getItem("token")) {
        if (this.normalMember) {
          this.$router.push("/index");
        } else {
          // 限时开通会员弹窗
          this.buy();
        }
      } else {
        // 显示登录弹窗
        if (this.keepEntry) {
          this.$alert({
            title: "提示",
            message: "当前页面已过期，请退出当前页面重新进入",
          });
          return;
        }
        if (this.initOlinstance) {
          this.loading = this.$loading("加载中...", { forbidClick: false });
          ans.track("vistor_click_quick_login", { namespace: this.namespace });
          this.initOlinstance.gateway();
        } else {
          this.showLogin();
        }
      }
    },

    async loginSuccess(userInfo) {
      if (userInfo.is_member) {
        this.$router.push("/index");
        return;
      }

      // await this.fetchPeriod(this.methods, this.packages);
      // if (this.normalMember) {
      //   return;
      // }
      // if (this.clickType === "open") {
      //   this.buy();
      // } else if (this.clickType === "tohome") {
      //   this.toHome();
      // }
    },

    totop() {
      animateScrollTo([null, 0], {
        elementToScroll: document.documentElement,
      });
      animateScrollTo([null, 0], {
        elementToScroll: document.body,
      });
    },

    open(item) {
      ans.track("vistor_click_pay", {
        item_code: this.currentPackage.item_code,
        channel: this.currentChannel.channel,
      });
      if (
        !this.checked &&
        this.currentChannel.channel !== this.alipayGoConfig.channel
      ) {
        this.$toast("请先勾选并同意协议");
        return;
      }
      this.clickType = "open";
      this.currentPackage = item;

      if (storage.getItem("token")) {
        // 限时开通会员弹窗
        this.buy();
      } else {
        if (this.keepEntry) {
          this.$alert({
            title: "提示",
            message: "当前页面已过期，请退出当前页面重新进入",
          });
          return;
        }
        // 显示登录弹窗
        if (this.initOlinstance) {
          this.loading = this.$loading("加载中...", { forbidClick: false });
          ans.track("vistor_click_quick_login", { namespace: this.namespace });
          this.initOlinstance.gateway();
        } else {
          this.showLogin();
        }
      }
    },

    // isPopup 是否是弹窗按钮触发
    buy(isPopupClick) {
      // 非keep app 不允许支付
      if (this.isWebchat && this.source !== "default") {
        // 增加日志
        window.DATAFLUX_RUM && window.DATAFLUX_RUM.addError(this.token);
        this.$alert({
          title: "温馨提示",
          message: this.$getConfigValue("KEEP_APP_OUTER_OPEN_MEMBER"),
          confirmButtonText: "我知道了",
        });
        return;
      }
      if (!this.currentChannel.channel) {
        this.$toast("请选择支付方式");
        return;
      }
      if (
        this.currentChannel.channel === this.alipayGoConfig.channel &&
        !isPopupClick
      ) {
        this.alipayPopup.show = true;
        return;
      }

      const querysearch = qs.parse(location.search, {
        ignoreQueryPrefix: true,
      });
      const params = {
        category_type: "vip",
        price: this.currentPackage.price * 100,
        path: encodeURIComponent("/payResult"),
      };
      if (Object.keys(querysearch).length) {
        params.utm_params = encodeURIComponent(JSON.stringify(querysearch));
      }
      const { currentPackage, currentChannel } = this;
      toPayV2(
        { ...currentPackage, name: currentPackage.orderName },
        currentPackage.isRenew ? "alipay_period" : currentChannel.channel,
        {
          order_source: encodeURIComponent("GoGo大会员"),
          activity: currentPackage.item_code,
          partner_jump_url: encodeURIComponent(
            window.location.origin +
              `/keepredirect.html?${qs.stringify(params)}`
          ),
          ...querysearch,
          price: currentPackage.price * 100,
          showSignResult: 1,
          partner_url: encodeURIComponent(location.href),
        }
      );
    },

    tohotel() {
      this.$router.push("/hotel/list?benefitType=hotel");
    },

    toviproomlink() {
      location.href =
        "http://network.dragonpass.com.cn/airport/list?agentId=14201&type=gt";
    },
  },
  beforeDestroy() {
    this.initOlinstance && this.initOlinstance.destory();
  },
  watch: {
    currentPackageIndex() {
      this.currentPackage = this.packages[this.currentPackageIndex];
    },
    currentPackage(val) {
      if (val.isRenew) {
        const methods = this.methods;
        this.filterMethods = methods.filter(
          (r) => r.channel === val.renewPackage.channel
        );
      } else {
        this.filterMethods = [...this.methods]
          .filter((item) => item.channel !== this.alipayGoConfig.channel)
          .filter((item) => item.channel !== this.alipayGoConfig.channel);
      }
    },
    filterMethods(val) {
      if (!val.some((r) => r.channel === this.currentChannel)) {
        this.currentChannel = val.length ? val[0] : {};
      }
    },
  },
};
</script>

<style lang="less" scoped>
.notice-bar {
  height: 24px;
  background: rgba(255, 79, 0, 0.9);
  font-size: 12px;
  color: #fff;
}

.keep-unlogin {
  overflow: hidden;
  position: relative;
  font-size: 14px;
  background: linear-gradient(#ff934b 0%, #fa5923 20%, #fa5923 100%);
  min-height: 100vh;
  /deep/ .van-image {
    [lazy="loading"] {
      max-height: 100px;
    }
  }
}
.keep-header {
  margin: 0 16px;
  margin-top: 52px;
  height: 107px;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.keep-package-desc {
  margin: 0 16px;
  margin-top: 8px;
}

.to-home {
  position: absolute;
  bottom: 0;
  right: -5px;
  width: 99px;
  height: 27px;
  background-image: url("https://common-h5-dev.xiangshuheika.com/static/upload/202505291301255a2643a.png");
  background-repeat: no-repeat;
  background-size: 100%;
}

.keep-packages {
  padding-top: 16px;
  margin: 0 16px;
  height: 66px;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
}

.pacakage-tag {
  position: absolute;
  right: 0;
  top: -15px;
  height: 15px;
  line-height: 15px;
  background: #d8d8d8 linear-gradient(136deg, #fd6e07 0%, #f71b00 100%);
  border-radius: 0px 8px 0px 8px;
  color: #fff;
  padding: 0 4px;
  font-size: 10px;
}

.keep-package-item {
  flex-shrink: 0;
  position: relative;
  margin-right: 8px;
  box-sizing: border-box;
  height: 54px;
  background: #ffffff;
  border-radius: 8px;
  flex: 1;
  &.active {
    background: linear-gradient(312deg, #fad6b4 0%, #ffead2 100%);
    &::after {
      content: "";
      position: absolute;
      bottom: -10px; /* 三角形高度 */
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 14px solid transparent;
      border-right: 14px solid transparent;
      border-top: 18px solid#fadec0;
    }
    &:first-child {
      &::after {
        left: 70%;
      }
    }
    &:last-child {
      &::after {
        left: 30%;
      }
    }
    .package-name {
      font-weight: 600;
    }
  }
}
.keep-package-inner {
  height: 54px;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.package-amount {
  font-weight: 600;
  font-size: 16px;
  color: #f35519;
  line-height: 16px;
  text-align: center;
  margin-top: 4px;
}

.face-value {
  margin-left: 4px;
  font-weight: 400;
  font-size: 10px;
  color: #666666;
  line-height: 10px;
  text-decoration-line: line-through;
}

.keep-package-button {
  padding: 0;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  height: 26px;
  border: none;
  background: linear-gradient(136deg, #ff6a00 0%, #f71b00 100%);
  margin-top: 8px;
}
.package-name {
  font-weight: 400;
  font-size: 14px;
  color: #222222;
  line-height: 20px;
  text-align: center;
  margin-top: 5px;
}

.animate-run {
  position: relative;
  overflow: hidden;
  &::after {
    content: "";
    width: 26px;
    height: 100px;
    opacity: 1;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.5)
    );
    position: absolute;
    left: 0;
    top: -20px;
    transform: rotate(30deg);
    animation: run 1s infinite;
    z-index: 100;
  }
}

.keep-agreement {
}

.keep-benefits {
  padding: 0 16px;
}

.benefit-item {
  margin-bottom: 24px;
}

.benefit-spu-item {
  & + .benefit-spu-item {
    margin-top: 12px;
  }
}

.benefit-top-left {
  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
  line-height: 24px;
  text-align: center;
  margin-bottom: 16px;
  margin-top: 24px;
  font-weight: 600;
}

.benefit-spu-top-label {
  line-height: 24px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  .benefit-spu-name {
    font-size: 16px;
    color: #000;
    font-weight: bold;
  }
  .benefit-spu-selling {
    position: absolute;
    width: 316px;
    height: 18px;
    background: #fcf2d7;
    left: 14px;
    bottom: 15px;
    z-index: 1;

    font-weight: 400;
    font-size: 10px;
    color: #ff6430;
    line-height: 18px;
    text-align: center;
  }
}

.benefit-spu-top {
  line-height: 24px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .benefit-spu-name {
    font-size: 16px;
    color: #000;
    font-weight: bold;
  }
}

.keep-rule {
  border-radius: 8px;
  border: 1px solid #ffffff;
  font-size: 12px;
  line-height: 1.5;
  color: #ffe9d5;
  padding: 15px 12px;
  &.isFold {
    display: none;
  }
  /deep/ font {
    color: #ffe9d5 !important;
  }
}

.height120 {
  height: 120px;

  &.is-renew {
    height: 200px;
  }
}
.height30 {
  height: 30px;
}

.fold-btn {
  width: 190px;
  height: 24px;
  line-height: 40px;
  margin: 24px auto 8px;
  border: 1px solid #ffffff;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 24px;
  text-align: center;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;

  .arrow {
    color: #ffe9d5;
    transform: rotate(-90deg);
    margin-left: 3px;
    font-size: 18px;
    background-size: 100%;
  }
  &.isFold {
    .arrow {
      transform: rotate(90deg);
    }
  }
}

.totop {
  position: fixed;
  width: 50px;
  height: 50px;
  background: url(../../assets/images/totop.png) no-repeat;
  background-size: 100%;
  right: 10px;
  bottom: 30%;
  display: none;
}

.fixed-contain {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-radius: 8px 8px 0px 0px;
  z-index: 100;
}
.normal-member {
  padding: 0;
  .fixed-used {
    height: 40px;
    line-height: 40px;
  }
  & + .height120 {
    height: 80px;
  }
}
.fixed-used {
  display: flex;
  align-items: center;
  text-align: center;
  height: 54px;
  border-radius: 27px;
  background: linear-gradient(124deg, #eeca8a 0%, #dbae74 100%);
  text-align: center;
  color: #fff;
  margin: 10px 16px;
  line-height: 54px;
  font-size: 16px;
  color: #fff;
  justify-content: center;
}

.footer-price {
  flex: 3;
  font-size: 22px;
  letter-spacing: 1px;
  color: #000;
  small {
    font-size: 14px;
    margin-right: 2px;
  }
}
.footer-facevalue {
  margin-left: 7px;
  font-size: 12px;
  letter-spacing: 0;
  text-decoration: line-through;
  opacity: 0.9;
}
.footer-text {
  flex: 2;
  position: relative;
  z-index: 1;
  &::after {
    content: "";
    width: 110%;
    height: 110%;
    position: absolute;
    left: 0;
    top: -10%;
    transform: skew(-20deg);
    background: #222;
    z-index: -1;
  }
}

.user-number {
  text-align: center;
  color: #999;
  font-size: 16px;
  width: fit-content;
  margin: 20px auto 10px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: -20px;
    width: 15px;
    height: 1px;
    top: 12px;
    background: #999;
  }
  &::before {
    content: "";
    position: absolute;
    top: 12px;
    right: -20px;
    width: 15px;
    height: 1px;
    background: #999;
  }
}

.count-down {
  display: inline-block;
  color: inherit;
  font-size: inherit;
}

.colon {
  margin: 0 1px;
  text-align: center;
}

.block {
  display: inline-block;
  text-align: center;
}

.logout-account {
  position: absolute;
  top: 16px;
  left: 0;
  width: 83px;
  height: 24px;
  background: #ffffff;
  border-radius: 0px 14px 14px 0px;
  opacity: 0.53;
  color: #fb5a3b;
  line-height: 24px;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  background-image: url("../../assets/images/keep-change-account.png");
  background-size: 10px;
  background-position: 8px center;
  background-repeat: no-repeat;
  text-indent: 22px;
}

.footer-count {
  position: absolute;
  right: 16px;
  top: 36px;
  z-index: 10;
  height: 22px;
  background: #fa5923;
  border-radius: 12px 12px 12px 0px;
  padding: 0 8px;
  text-align: center;
  line-height: 22px;
  color: #fff;
  font-size: 12px;
}

.package-methods {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 20px 0px 26px 24px;
  &.footer-package-methods {
    margin-bottom: 20px;
    .actived {
    }
  }
}

.method-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 19px;

  &.wechat_wap {
    .method-check {
      border-color: rgba(4, 200, 0, 1);
      .method-onCheck {
        background: rgba(4, 200, 0, 1);
      }
    }
    .method-name {
      color: rgba(4, 200, 0, 1);
    }
  }
  .method-check {
    width: 12px;
    height: 12px;
    border: 1px solid #15a1f1;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    .method-onCheck {
      background: #15a1f1;
      border-radius: 50%;
      width: 6px;
      height: 6px;
    }
  }
  .method-inner {
    display: flex;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
  }
  &.actived {
  }
  .method-name {
    font-weight: 400;
    font-size: 12px;
    color: #15a1f1;
    line-height: 17px;
    margin-left: 8px;
  }
}

.benefit-spu-inner {
  position: relative;

  .benefit-spu-right {
    position: absolute;
    right: 17px;
    top: 18px;
    font-weight: 400;
    font-size: 10px;
    color: #666666;
    line-height: 12px;
    z-index: 1;
  }
}

.benefit_detail_img {
  margin-left: -12px;
}

.agreement-wrap {
  margin: 12px 24px 24px 24px;
  display: flex;
  align-items: flex-start;

  .checkbox {
    flex-shrink: 0;
    margin-right: 4px;

    /deep/ .van-icon {
      border: 1px solid rgba(193, 144, 48, 0.3);
      border-radius: 4px;
    }
  }

  .agreement-text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: #000000;
    line-height: 14px;

    div {
      margin-bottom: 4px;
    }
  }
}

.fixed-contain-inner {
  padding: 12px 16px 20px;
  button {
    height: 54px;
    background: linear-gradient(124deg, #eeca8a 0%, #dbae74 100%);
    border: none;
    font-size: 16px;
    color: #000;
  }
}
</style>